/**
 * Neu-seit-letztem-Besuch (Juni 2026) — dezenter Hinweiston per Web-Audio.
 *
 * Kein Audiodatei-Asset: Der Zwei-Ton-Chime (G5 → D6, ~0,4 s, leise) wird
 * direkt im Code erzeugt. `primeAudioContext()` MUSS innerhalb einer
 * User-Geste aufgerufen werden (PIN-Tastendruck) — der so erzeugte
 * AudioContext bleibt „running" und darf den Ton auch nach der asynchronen
 * Login-Antwort abspielen (Browser-Autoplay-Policy). Beide Funktionen sind
 * fail-soft: Fehler werden geschluckt, der Login läuft immer weiter.
 */
let _ctx = null;

export function primeAudioContext() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    if (!_ctx) _ctx = new AC();
    if (_ctx.state === "suspended" && typeof _ctx.resume === "function") {
      _ctx.resume();
    }
    return _ctx;
  } catch {
    return null;
  }
}

export function playNewTasksChime() {
  try {
    const ctx = _ctx || primeAudioContext();
    if (!ctx) return false;
    const t0 = ctx.currentTime;
    // Zwei kurze, freundliche Sinustöne (aufsteigend), leiser Pegel.
    [
      [784, 0], // G5
      [1175, 0.16], // D6
    ].forEach(([freq, offset]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t0 + offset);
      gain.gain.exponentialRampToValueAtTime(0.09, t0 + offset + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + offset + 0.3);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t0 + offset);
      osc.stop(t0 + offset + 0.32);
    });
    return true;
  } catch {
    return false;
  }
}
